import { Component, OnInit } from '@angular/core';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from '../utils/error-handler';
import { SwabSampleService } from './swab-sample.service';
import { SwabSample } from './models/swabSample';
import { SelectableLab } from '../carrier/selectable-lab';
import { Gender } from './models/gender';
import { LazyLoadEvent, DataTable } from '../../../node_modules/primeng/primeng';


@Component({
  selector: 'app-swab-sample',
  templateUrl: './swab-sample.component.html',
  styleUrls: ['./swab-sample.component.css']
})
export class SwabSampleComponent implements OnInit {

  tableCols: any[];
  title: string = "Swab Samples";
  swabSamplesList: SwabSample[];
  selectedLab:SelectableLab;
  selectedSwabSample: any;
  sampleCount: number;
  swabSample:any;

  barcodeInput: string = "";
  clientIdInput: string = "";
  plateIdInput: string = "";
  orderItemIdInput: string = "";

  displaySwabSampleDialog: boolean;
  isNewSwabSample: boolean;
  displayDeleteDialog: boolean = false;
  loading: boolean;

  genderOptions:Gender[];
  isGender:string = "petGender";
  selectedGender:Gender;
  isActivationDate:string = "activationDate";
  selectedActivationDate:Date;
  isReceivedDate:string = "receivedDate";
  selectedReceivedDate:Date;

  errorHandler: ErrorHandler = new ErrorHandler;
  
  constructor(private _messageService: MessagesService, private _swabSampleService: SwabSampleService) {    
  }

  ngOnInit() {
    this.selectedLab = JSON.parse(localStorage.getItem('lab'));    
    console.log("selected lab"+ this.selectedLab);
    
    this.genderOptions =  [{name:"Male", code:"Male"}, {name:"Female", code:"Female"}];
     this.swabSamplesList = [];
     this.tableCols = [
      { field: 'sampleBarCode', header: 'Barcode' },
      { field: 'petName', header: 'Subject Name' },
      { field: 'petGender', header: 'Subject Gender' },
      { field: 'clientId', header: 'Client ID' },
      { field: 'orderItemId', header: 'Order Item ID' },
      { field: 'activationDate', header: 'Activation Date'},
      { field: 'plateID', header: 'Plate ID' },
      { field: 'positionInPlate', header: 'Position In Plate' },
      { field: 'storageID', header: 'Storage ID' },
      { field: 'comments', header: 'Comments' },
      { field: 'awbTracking', header: 'AWB - Tracking' },
      { field: 'receivedDate', header: 'Received Date' },
      { field: 'qcCheck', header: 'QC Check' }
    ];
 
    //Lazy loading is automatic
    this.loading = true;
  }

  /**
   * @description To load the data of Swab Samples for selected Lab
   * @param event 
   */
  getSwabSampleData(event: LazyLoadEvent){

    let page: number;
    if (!event) {
      page = 0;
    } else {
      //Page = first row offset / number of rows per page
      //Example: 0 = 0 / 20 or 2 = 40 / 20
      page = (event.first / event.rows);
    }

    this._swabSampleService.getSwabSamplesByFilterPaginated(this.selectedLab.lab, this.barcodeInput, this.clientIdInput, this.plateIdInput, this.orderItemIdInput, page).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.swabSamplesList = results.data.swabSamplesList;
        this.sampleCount = results.data.count;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);        
      }
    );
    this.loading = false;
  }

  /**
   * @description Exports the current table data (all pages after filtering) as a csv file
   * @param datatable 
   */
  exportCSV(datatable: DataTable) {
    this._swabSampleService.getSwabSamplesByFilter(this.selectedLab.lab, this.barcodeInput, this.clientIdInput, this.plateIdInput, this.orderItemIdInput).subscribe(
      results => {
        if (!results) {
          return;
        }
        datatable.value = results.data.swabSamplesList;
        datatable.exportCSV();
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);        
      }
    );
    this.loading = false;
  }

  /**
   * @description This function is triggered on selecting the row in the table. It opens a popup for selected Swab Sample
   * @param event 
   */
  onRowSelect(event) {
    this.isNewSwabSample = false;
    this.swabSample = this.cloneSwabSample(event.data);
    this.getSavedGender(this.swabSample);
    if(this.swabSample.activationDate){
      this.selectedActivationDate = new Date(this.swabSample.activationDate);
    }else{
      this.selectedActivationDate = null;
    }
    if(this.swabSample.receivedDate){
      this.selectedReceivedDate = new Date(this.swabSample.receivedDate);
    }else{
      this.selectedReceivedDate = null;
    }   
    this.displaySwabSampleDialog = true;    
  }

  /**
   * @description This method to retrive the saved gender for selected sample
   * @param swabSample 
   */
  getSavedGender(swabSample){
    this.genderOptions.forEach(gender => {
      if(swabSample.petGender == gender.code){
        this.selectedGender = gender;
      }
    });
  }
  
  /**
   * @description This function is triggered on click of add button.It displays the popup to add the data into the table.
   */
  showDialogToAddSwabSample() {
    this.isNewSwabSample = true;
    this.swabSample = {};
    this.selectedGender =  new Gender();
    this.displaySwabSampleDialog = true;
    this.selectedActivationDate = null;
    this.selectedReceivedDate = null;
  }

  /**
   * @description This function is used to add/update samples into the Db.
   */
  saveSwabSampleList() {
    let swabSamplesList = this.swabSamplesList;
    if (this.isNewSwabSample) {
      this.saveSwabSample(swabSamplesList);
    }
    else {
      this.updateSwabSample(swabSamplesList);
    }
  }

  /**
   * @description This function deletes the data from the db
   */
  deleteSwabSample() {
  }

  /**
   * @description This function is used to clone the list for update.
   * @param list 
   */
  cloneSwabSample(list: any): any {
    let swabSample = {};
    for (let prop in list) {
      swabSample[prop] = list[prop];
    }
    return swabSample;
  }

  /**
   * @description Updates the swab sampleData
   * @param swabSamplesList 
   */
  updateSwabSample(swabSamplesList) {
    this.swabSample.petGender = this.selectedGender.code;
    this.swabSample.activationDate = this.selectedActivationDate.toDateString();
    this.swabSample.receivedDate = this.selectedReceivedDate.toDateString();
    this._swabSampleService.updateSwabSample(this.swabSample).subscribe(
      results => {
        if (!results) {
          return;
        }
        swabSamplesList[this.swabSamplesList.indexOf(this.selectedSwabSample)] = results.data;
        this.swabSamplesList = swabSamplesList;
        this.swabSample = null;
        this.displaySwabSampleDialog = false;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
        this.displaySwabSampleDialog = true;
      }
    );
  }

  /**
   * @description Saves the swab sampleData
   * @param swabSamplesList 
   */
  saveSwabSample(swabSamplesList) {
    this.swabSample.lab = this.selectedLab.lab;
    this.swabSample.petGender = this.selectedGender.code;
    this.swabSample.activationDate = this.selectedActivationDate.toDateString();
    this.swabSample.receivedDate = this.selectedReceivedDate.toDateString();
    this._swabSampleService.addSwabSample(this.swabSample).subscribe(
      results => {
        if (!results) {
          return;
        }
        swabSamplesList = this.swabSamplesList;
        console.log("swabSample is:", results.data);
        swabSamplesList.push(results.data);
        this.swabSamplesList = swabSamplesList;
        this.swabSample = null;
        this.displaySwabSampleDialog = false;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
        this.displaySwabSampleDialog = true;
      }
    );
  }

  /**
   * @description Returns true if the save button has to be disabled for the editing popup 
   */
  isSaveDisabled() {
    if(!this.swabSample){
      return true;
    }
    /*
    if( (!this.swabSample.petName) ||
        (!this.swabSample.sampleBarCode) ||
        (!this.selectedGender) ||
        (!this.swabSample.orderItemId) ||
        (!this.selectedActivationDate) ||
        (!this.swabSample.plateId) ||
        (!this.swabSample.positionInPlate) ||
        (!this.swabSample.storageID) ||
        (!this.swabSample.comments) ||
        (!this.swabSample.awbTracking) ||
        (!this.selectedReceivedDate) ||
        (!this.swabSample.qcScan) ||
        (!this.swabSample.qcCheck) ||
        (!this.swabSample.index)
      ){
        return true;
      }
      */    
    return false;
  }

}
